import * as C from "react";
import { useRef as ye, useState as fr, useMemo as Be, useContext as Ye, useEffect as cr, createContext as dr } from "react";
import { w as D, a8 as gr, a9 as Ze, aa as vr, p as U, _ as R, v as k, B as Qe, E as Xe, e as oe, f as d, a6 as q, d as le, ab as ie, ac as Q, ad as Y, ae as Ie, z as Ae, o as er, i as ue } from "./index-CjjiqU7h.mjs";
import { _ as fe, a as B } from "./asyncToGenerator-STwiOfG5.mjs";
import { t as hr } from "./toArray-C1Af_up9.mjs";
var X = "RC_FORM_INTERNAL_HOOKS", S = function() {
  D(!1, "Can not find FormContext. Please make sure you wrap Field under Form.");
}, ne = /* @__PURE__ */ C.createContext({
  getFieldValue: S,
  getFieldsValue: S,
  getFieldError: S,
  getFieldWarning: S,
  getFieldsError: S,
  isFieldsTouched: S,
  isFieldTouched: S,
  isFieldValidating: S,
  isFieldsValidating: S,
  resetFields: S,
  setFields: S,
  setFieldValue: S,
  setFieldsValue: S,
  validateFields: S,
  submit: S,
  getInternalHooks: function() {
    return S(), {
      dispatch: S,
      initEntityValue: S,
      registerField: S,
      useSubscribe: S,
      setInitialValues: S,
      destroyForm: S,
      setCallbacks: S,
      registerWatch: S,
      getFields: S,
      setValidateMessages: S,
      setPreserve: S,
      getInitialValue: S
    };
  }
}), he = /* @__PURE__ */ C.createContext(null);
function we(s) {
  return s == null ? [] : Array.isArray(s) ? s : [s];
}
function mr(s) {
  return s && !!s._init;
}
function Ve() {
  return {
    default: "Validation error on field %s",
    required: "%s is required",
    enum: "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      boolean: "%s is not a %s",
      integer: "%s is not an %s",
      float: "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function() {
      var t = JSON.parse(JSON.stringify(this));
      return t.clone = this.clone, t;
    }
  };
}
var Ee = Ve();
function pr(s) {
  try {
    return Function.toString.call(s).indexOf("[native code]") !== -1;
  } catch {
    return typeof s == "function";
  }
}
function Fr(s, t, e) {
  if (gr())
    return Reflect.construct.apply(null, arguments);
  var n = [null];
  n.push.apply(n, t);
  var r = new (s.bind.apply(s, n))();
  return e && Ze(r, e.prototype), r;
}
function be(s) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return be = function(n) {
    if (n === null || !pr(n))
      return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(n))
        return t.get(n);
      t.set(n, r);
    }
    function r() {
      return Fr(n, arguments, vr(this).constructor);
    }
    return r.prototype = Object.create(n.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Ze(r, n);
  }, be(s);
}
var yr = /%[sdj%]/g, rr = function() {
};
typeof process < "u" && process.env && process.env.NODE_ENV !== "production" && typeof window < "u" && typeof document < "u" && (rr = function(t, e) {
  typeof console < "u" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING > "u" && e.every(function(n) {
    return typeof n == "string";
  }) && console.warn(t, e);
});
function Pe(s) {
  if (!s || !s.length)
    return null;
  var t = {};
  return s.forEach(function(e) {
    var n = e.field;
    t[n] = t[n] || [], t[n].push(e);
  }), t;
}
function H(s) {
  for (var t = arguments.length, e = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    e[n - 1] = arguments[n];
  var r = 0, i = e.length;
  if (typeof s == "function")
    return s.apply(null, e);
  if (typeof s == "string") {
    var a = s.replace(yr, function(u) {
      if (u === "%%")
        return "%";
      if (r >= i)
        return u;
      switch (u) {
        case "%s":
          return String(e[r++]);
        case "%d":
          return Number(e[r++]);
        case "%j":
          try {
            return JSON.stringify(e[r++]);
          } catch {
            return "[Circular]";
          }
          break;
        default:
          return u;
      }
    });
    return a;
  }
  return s;
}
function wr(s) {
  return s === "string" || s === "url" || s === "hex" || s === "email" || s === "date" || s === "pattern";
}
function j(s, t) {
  return !!(s == null || t === "array" && Array.isArray(s) && !s.length || wr(t) && typeof s == "string" && !s);
}
function Vr(s, t, e) {
  var n = [], r = 0, i = s.length;
  function a(u) {
    n.push.apply(n, k(u || [])), r++, r === i && e(n);
  }
  s.forEach(function(u) {
    t(u, a);
  });
}
function Le(s, t, e) {
  var n = 0, r = s.length;
  function i(a) {
    if (a && a.length) {
      e(a);
      return;
    }
    var u = n;
    n = n + 1, u < r ? t(s[u], i) : e([]);
  }
  i([]);
}
function Er(s) {
  var t = [];
  return Object.keys(s).forEach(function(e) {
    t.push.apply(t, k(s[e] || []));
  }), t;
}
var je = /* @__PURE__ */ function(s) {
  Qe(e, s);
  var t = Xe(e);
  function e(n, r) {
    var i;
    return oe(this, e), i = t.call(this, "Async Validation Error"), d(q(i), "errors", void 0), d(q(i), "fields", void 0), i.errors = n, i.fields = r, i;
  }
  return le(e);
}(/* @__PURE__ */ be(Error));
function br(s, t, e, n, r) {
  if (t.first) {
    var i = new Promise(function(h, E) {
      var p = function(F) {
        return n(F), F.length ? E(new je(F, Pe(F))) : h(r);
      }, m = Er(s);
      Le(m, e, p);
    });
    return i.catch(function(h) {
      return h;
    }), i;
  }
  var a = t.firstFields === !0 ? Object.keys(s) : t.firstFields || [], u = Object.keys(s), l = u.length, f = 0, o = [], g = new Promise(function(h, E) {
    var p = function(c) {
      if (o.push.apply(o, c), f++, f === l)
        return n(o), o.length ? E(new je(o, Pe(o))) : h(r);
    };
    u.length || (n(o), h(r)), u.forEach(function(m) {
      var c = s[m];
      a.indexOf(m) !== -1 ? Le(c, e, p) : Vr(c, e, p);
    });
  });
  return g.catch(function(h) {
    return h;
  }), g;
}
function Pr(s) {
  return !!(s && s.message !== void 0);
}
function Cr(s, t) {
  for (var e = s, n = 0; n < t.length; n++) {
    if (e == null)
      return e;
    e = e[t[n]];
  }
  return e;
}
function De(s, t) {
  return function(e) {
    var n;
    return s.fullFields ? n = Cr(t, s.fullFields) : n = t[e.field || s.fullField], Pr(e) ? (e.field = e.field || s.fullField, e.fieldValue = n, e) : {
      message: typeof e == "function" ? e() : e,
      fieldValue: n,
      field: e.field || s.fullField
    };
  };
}
function _e(s, t) {
  if (t) {
    for (var e in t)
      if (t.hasOwnProperty(e)) {
        var n = t[e];
        U(n) === "object" && U(s[e]) === "object" ? s[e] = R(R({}, s[e]), n) : s[e] = n;
      }
  }
  return s;
}
var ee = "enum", Nr = function(t, e, n, r, i) {
  t[ee] = Array.isArray(t[ee]) ? t[ee] : [], t[ee].indexOf(e) === -1 && r.push(H(i.messages[ee], t.fullField, t[ee].join(", ")));
}, Rr = function(t, e, n, r, i) {
  if (t.pattern) {
    if (t.pattern instanceof RegExp)
      t.pattern.lastIndex = 0, t.pattern.test(e) || r.push(H(i.messages.pattern.mismatch, t.fullField, e, t.pattern));
    else if (typeof t.pattern == "string") {
      var a = new RegExp(t.pattern);
      a.test(e) || r.push(H(i.messages.pattern.mismatch, t.fullField, e, t.pattern));
    }
  }
}, xr = function(t, e, n, r, i) {
  var a = typeof t.len == "number", u = typeof t.min == "number", l = typeof t.max == "number", f = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, o = e, g = null, h = typeof e == "number", E = typeof e == "string", p = Array.isArray(e);
  if (h ? g = "number" : E ? g = "string" : p && (g = "array"), !g)
    return !1;
  p && (o = e.length), E && (o = e.replace(f, "_").length), a ? o !== t.len && r.push(H(i.messages[g].len, t.fullField, t.len)) : u && !l && o < t.min ? r.push(H(i.messages[g].min, t.fullField, t.min)) : l && !u && o > t.max ? r.push(H(i.messages[g].max, t.fullField, t.max)) : u && l && (o < t.min || o > t.max) && r.push(H(i.messages[g].range, t.fullField, t.min, t.max));
}, tr = function(t, e, n, r, i, a) {
  t.required && (!n.hasOwnProperty(t.field) || j(e, a || t.type)) && r.push(H(i.messages.required, t.fullField));
}, ve;
const kr = function() {
  if (ve)
    return ve;
  var s = "[a-fA-F\\d:]", t = function($) {
    return $ && $.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(s, ")|(?<=").concat(s, ")(?=\\s|$))") : "";
  }, e = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}", n = "[a-fA-F\\d]{1,4}", r = [
    "(?:".concat(n, ":){7}(?:").concat(n, "|:)"),
    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
    "(?:".concat(n, ":){6}(?:").concat(e, "|:").concat(n, "|:)"),
    // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::
    "(?:".concat(n, ":){5}(?::").concat(e, "|(?::").concat(n, "){1,2}|:)"),
    // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::
    "(?:".concat(n, ":){4}(?:(?::").concat(n, "){0,1}:").concat(e, "|(?::").concat(n, "){1,3}|:)"),
    // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::
    "(?:".concat(n, ":){3}(?:(?::").concat(n, "){0,2}:").concat(e, "|(?::").concat(n, "){1,4}|:)"),
    // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::
    "(?:".concat(n, ":){2}(?:(?::").concat(n, "){0,3}:").concat(e, "|(?::").concat(n, "){1,5}|:)"),
    // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::
    "(?:".concat(n, ":){1}(?:(?::").concat(n, "){0,4}:").concat(e, "|(?::").concat(n, "){1,6}|:)"),
    // 1::              1::3:4:5:6:7:8   1::8            1::
    "(?::(?:(?::".concat(n, "){0,5}:").concat(e, "|(?::").concat(n, "){1,7}|:))")
    // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
  ], i = "(?:%[0-9a-zA-Z]{1,})?", a = "(?:".concat(r.join("|"), ")").concat(i), u = new RegExp("(?:^".concat(e, "$)|(?:^").concat(a, "$)")), l = new RegExp("^".concat(e, "$")), f = new RegExp("^".concat(a, "$")), o = function($) {
    return $ && $.exact ? u : new RegExp("(?:".concat(t($)).concat(e).concat(t($), ")|(?:").concat(t($)).concat(a).concat(t($), ")"), "g");
  };
  o.v4 = function(V) {
    return V && V.exact ? l : new RegExp("".concat(t(V)).concat(e).concat(t(V)), "g");
  }, o.v6 = function(V) {
    return V && V.exact ? f : new RegExp("".concat(t(V)).concat(a).concat(t(V)), "g");
  };
  var g = "(?:(?:[a-z]+:)?//)", h = "(?:\\S+(?::\\S*)?@)?", E = o.v4().source, p = o.v6().source, m = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)", c = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*", F = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))", v = "(?::\\d{2,5})?", y = '(?:[/?#][^\\s"]*)?', P = "(?:".concat(g, "|www\\.)").concat(h, "(?:localhost|").concat(E, "|").concat(p, "|").concat(m).concat(c).concat(F, ")").concat(v).concat(y);
  return ve = new RegExp("(?:^".concat(P, "$)"), "i"), ve;
};
var Ue = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
}, ae = {
  integer: function(t) {
    return ae.number(t) && parseInt(t, 10) === t;
  },
  float: function(t) {
    return ae.number(t) && !ae.integer(t);
  },
  array: function(t) {
    return Array.isArray(t);
  },
  regexp: function(t) {
    if (t instanceof RegExp)
      return !0;
    try {
      return !!new RegExp(t);
    } catch {
      return !1;
    }
  },
  date: function(t) {
    return typeof t.getTime == "function" && typeof t.getMonth == "function" && typeof t.getYear == "function" && !isNaN(t.getTime());
  },
  number: function(t) {
    return isNaN(t) ? !1 : typeof t == "number";
  },
  object: function(t) {
    return U(t) === "object" && !ae.array(t);
  },
  method: function(t) {
    return typeof t == "function";
  },
  email: function(t) {
    return typeof t == "string" && t.length <= 320 && !!t.match(Ue.email);
  },
  url: function(t) {
    return typeof t == "string" && t.length <= 2048 && !!t.match(kr());
  },
  hex: function(t) {
    return typeof t == "string" && !!t.match(Ue.hex);
  }
}, Or = function(t, e, n, r, i) {
  if (t.required && e === void 0) {
    tr(t, e, n, r, i);
    return;
  }
  var a = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"], u = t.type;
  a.indexOf(u) > -1 ? ae[u](e) || r.push(H(i.messages.types[u], t.fullField, t.type)) : u && U(e) !== t.type && r.push(H(i.messages.types[u], t.fullField, t.type));
}, Ar = function(t, e, n, r, i) {
  (/^\s+$/.test(e) || e === "") && r.push(H(i.messages.whitespace, t.fullField));
};
const A = {
  required: tr,
  whitespace: Ar,
  type: Or,
  range: xr,
  enum: Nr,
  pattern: Rr
};
var $r = function(t, e, n, r, i) {
  var a = [], u = t.required || !t.required && r.hasOwnProperty(t.field);
  if (u) {
    if (j(e) && !t.required)
      return n();
    A.required(t, e, r, a, i);
  }
  n(a);
}, qr = function(t, e, n, r, i) {
  var a = [], u = t.required || !t.required && r.hasOwnProperty(t.field);
  if (u) {
    if (e == null && !t.required)
      return n();
    A.required(t, e, r, a, i, "array"), e != null && (A.type(t, e, r, a, i), A.range(t, e, r, a, i));
  }
  n(a);
}, Mr = function(t, e, n, r, i) {
  var a = [], u = t.required || !t.required && r.hasOwnProperty(t.field);
  if (u) {
    if (j(e) && !t.required)
      return n();
    A.required(t, e, r, a, i), e !== void 0 && A.type(t, e, r, a, i);
  }
  n(a);
}, Sr = function(t, e, n, r, i) {
  var a = [], u = t.required || !t.required && r.hasOwnProperty(t.field);
  if (u) {
    if (j(e, "date") && !t.required)
      return n();
    if (A.required(t, e, r, a, i), !j(e, "date")) {
      var l;
      e instanceof Date ? l = e : l = new Date(e), A.type(t, l, r, a, i), l && A.range(t, l.getTime(), r, a, i);
    }
  }
  n(a);
}, Tr = "enum", Ir = function(t, e, n, r, i) {
  var a = [], u = t.required || !t.required && r.hasOwnProperty(t.field);
  if (u) {
    if (j(e) && !t.required)
      return n();
    A.required(t, e, r, a, i), e !== void 0 && A[Tr](t, e, r, a, i);
  }
  n(a);
}, Lr = function(t, e, n, r, i) {
  var a = [], u = t.required || !t.required && r.hasOwnProperty(t.field);
  if (u) {
    if (j(e) && !t.required)
      return n();
    A.required(t, e, r, a, i), e !== void 0 && (A.type(t, e, r, a, i), A.range(t, e, r, a, i));
  }
  n(a);
}, jr = function(t, e, n, r, i) {
  var a = [], u = t.required || !t.required && r.hasOwnProperty(t.field);
  if (u) {
    if (j(e) && !t.required)
      return n();
    A.required(t, e, r, a, i), e !== void 0 && (A.type(t, e, r, a, i), A.range(t, e, r, a, i));
  }
  n(a);
}, Dr = function(t, e, n, r, i) {
  var a = [], u = t.required || !t.required && r.hasOwnProperty(t.field);
  if (u) {
    if (j(e) && !t.required)
      return n();
    A.required(t, e, r, a, i), e !== void 0 && A.type(t, e, r, a, i);
  }
  n(a);
}, _r = function(t, e, n, r, i) {
  var a = [], u = t.required || !t.required && r.hasOwnProperty(t.field);
  if (u) {
    if (e === "" && (e = void 0), j(e) && !t.required)
      return n();
    A.required(t, e, r, a, i), e !== void 0 && (A.type(t, e, r, a, i), A.range(t, e, r, a, i));
  }
  n(a);
}, Ur = function(t, e, n, r, i) {
  var a = [], u = t.required || !t.required && r.hasOwnProperty(t.field);
  if (u) {
    if (j(e) && !t.required)
      return n();
    A.required(t, e, r, a, i), e !== void 0 && A.type(t, e, r, a, i);
  }
  n(a);
}, Wr = function(t, e, n, r, i) {
  var a = [], u = t.required || !t.required && r.hasOwnProperty(t.field);
  if (u) {
    if (j(e, "string") && !t.required)
      return n();
    A.required(t, e, r, a, i), j(e, "string") || A.pattern(t, e, r, a, i);
  }
  n(a);
}, Hr = function(t, e, n, r, i) {
  var a = [], u = t.required || !t.required && r.hasOwnProperty(t.field);
  if (u) {
    if (j(e) && !t.required)
      return n();
    A.required(t, e, r, a, i), j(e) || A.type(t, e, r, a, i);
  }
  n(a);
}, zr = function(t, e, n, r, i) {
  var a = [], u = Array.isArray(e) ? "array" : U(e);
  A.required(t, e, r, a, i, u), n(a);
}, Kr = function(t, e, n, r, i) {
  var a = [], u = t.required || !t.required && r.hasOwnProperty(t.field);
  if (u) {
    if (j(e, "string") && !t.required)
      return n();
    A.required(t, e, r, a, i, "string"), j(e, "string") || (A.type(t, e, r, a, i), A.range(t, e, r, a, i), A.pattern(t, e, r, a, i), t.whitespace === !0 && A.whitespace(t, e, r, a, i));
  }
  n(a);
}, pe = function(t, e, n, r, i) {
  var a = t.type, u = [], l = t.required || !t.required && r.hasOwnProperty(t.field);
  if (l) {
    if (j(e, a) && !t.required)
      return n();
    A.required(t, e, r, u, i, a), j(e, a) || A.type(t, e, r, u, i);
  }
  n(u);
};
const se = {
  string: Kr,
  method: Dr,
  number: _r,
  boolean: Mr,
  regexp: Hr,
  integer: jr,
  float: Lr,
  array: qr,
  object: Ur,
  enum: Ir,
  pattern: Wr,
  date: Sr,
  url: pe,
  hex: pe,
  email: pe,
  required: zr,
  any: $r
};
var ce = /* @__PURE__ */ function() {
  function s(t) {
    oe(this, s), d(this, "rules", null), d(this, "_messages", Ee), this.define(t);
  }
  return le(s, [{
    key: "define",
    value: function(e) {
      var n = this;
      if (!e)
        throw new Error("Cannot configure a schema with no rules");
      if (U(e) !== "object" || Array.isArray(e))
        throw new Error("Rules must be an object");
      this.rules = {}, Object.keys(e).forEach(function(r) {
        var i = e[r];
        n.rules[r] = Array.isArray(i) ? i : [i];
      });
    }
  }, {
    key: "messages",
    value: function(e) {
      return e && (this._messages = _e(Ve(), e)), this._messages;
    }
  }, {
    key: "validate",
    value: function(e) {
      var n = this, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
      }, a = e, u = r, l = i;
      if (typeof u == "function" && (l = u, u = {}), !this.rules || Object.keys(this.rules).length === 0)
        return l && l(null, a), Promise.resolve(a);
      function f(p) {
        var m = [], c = {};
        function F(y) {
          if (Array.isArray(y)) {
            var P;
            m = (P = m).concat.apply(P, k(y));
          } else
            m.push(y);
        }
        for (var v = 0; v < p.length; v++)
          F(p[v]);
        m.length ? (c = Pe(m), l(m, c)) : l(null, a);
      }
      if (u.messages) {
        var o = this.messages();
        o === Ee && (o = Ve()), _e(o, u.messages), u.messages = o;
      } else
        u.messages = this.messages();
      var g = {}, h = u.keys || Object.keys(this.rules);
      h.forEach(function(p) {
        var m = n.rules[p], c = a[p];
        m.forEach(function(F) {
          var v = F;
          typeof v.transform == "function" && (a === e && (a = R({}, a)), c = a[p] = v.transform(c), c != null && (v.type = v.type || (Array.isArray(c) ? "array" : U(c)))), typeof v == "function" ? v = {
            validator: v
          } : v = R({}, v), v.validator = n.getValidationMethod(v), v.validator && (v.field = p, v.fullField = v.fullField || p, v.type = n.getType(v), g[p] = g[p] || [], g[p].push({
            rule: v,
            value: c,
            source: a,
            field: p
          }));
        });
      });
      var E = {};
      return br(g, u, function(p, m) {
        var c = p.rule, F = (c.type === "object" || c.type === "array") && (U(c.fields) === "object" || U(c.defaultField) === "object");
        F = F && (c.required || !c.required && p.value), c.field = p.field;
        function v(N, O) {
          return R(R({}, O), {}, {
            fullField: "".concat(c.fullField, ".").concat(N),
            fullFields: c.fullFields ? [].concat(k(c.fullFields), [N]) : [N]
          });
        }
        function y() {
          var N = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], O = Array.isArray(N) ? N : [N];
          !u.suppressWarning && O.length && s.warning("async-validator:", O), O.length && c.message !== void 0 && (O = [].concat(c.message));
          var w = O.map(De(c, a));
          if (u.first && w.length)
            return E[c.field] = 1, m(w);
          if (!F)
            m(w);
          else {
            if (c.required && !p.value)
              return c.message !== void 0 ? w = [].concat(c.message).map(De(c, a)) : u.error && (w = [u.error(c, H(u.messages.required, c.field))]), m(w);
            var b = {};
            c.defaultField && Object.keys(p.value).map(function(T) {
              b[T] = c.defaultField;
            }), b = R(R({}, b), p.rule.fields);
            var x = {};
            Object.keys(b).forEach(function(T) {
              var M = b[T], K = Array.isArray(M) ? M : [M];
              x[T] = K.map(v.bind(null, T));
            });
            var I = new s(x);
            I.messages(u.messages), p.rule.options && (p.rule.options.messages = u.messages, p.rule.options.error = u.error), I.validate(p.value, p.rule.options || u, function(T) {
              var M = [];
              w && w.length && M.push.apply(M, k(w)), T && T.length && M.push.apply(M, k(T)), m(M.length ? M : null);
            });
          }
        }
        var P;
        if (c.asyncValidator)
          P = c.asyncValidator(c, p.value, y, p.source, u);
        else if (c.validator) {
          try {
            P = c.validator(c, p.value, y, p.source, u);
          } catch (N) {
            var V, $;
            (V = ($ = console).error) === null || V === void 0 || V.call($, N), u.suppressValidatorError || setTimeout(function() {
              throw N;
            }, 0), y(N.message);
          }
          P === !0 ? y() : P === !1 ? y(typeof c.message == "function" ? c.message(c.fullField || c.field) : c.message || "".concat(c.fullField || c.field, " fails")) : P instanceof Array ? y(P) : P instanceof Error && y(P.message);
        }
        P && P.then && P.then(function() {
          return y();
        }, function(N) {
          return y(N);
        });
      }, function(p) {
        f(p);
      }, a);
    }
  }, {
    key: "getType",
    value: function(e) {
      if (e.type === void 0 && e.pattern instanceof RegExp && (e.type = "pattern"), typeof e.validator != "function" && e.type && !se.hasOwnProperty(e.type))
        throw new Error(H("Unknown rule type %s", e.type));
      return e.type || "string";
    }
  }, {
    key: "getValidationMethod",
    value: function(e) {
      if (typeof e.validator == "function")
        return e.validator;
      var n = Object.keys(e), r = n.indexOf("message");
      return r !== -1 && n.splice(r, 1), n.length === 1 && n[0] === "required" ? se.required : se[this.getType(e)] || void 0;
    }
  }]), s;
}();
d(ce, "register", function(t, e) {
  if (typeof e != "function")
    throw new Error("Cannot register a validator by type, validator is not a function");
  se[t] = e;
});
d(ce, "warning", rr);
d(ce, "messages", Ee);
d(ce, "validators", se);
var W = "'${name}' is not a valid ${type}", nr = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: W,
    method: W,
    array: W,
    object: W,
    number: W,
    date: W,
    boolean: W,
    integer: W,
    float: W,
    regexp: W,
    email: W,
    url: W,
    hex: W
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
}, We = ce;
function Gr(s, t) {
  return s.replace(/\$\{\w+\}/g, function(e) {
    var n = e.slice(2, -1);
    return t[n];
  });
}
var He = "CODE_LOGIC_ERROR";
function Ce(s, t, e, n, r) {
  return Ne.apply(this, arguments);
}
function Ne() {
  return Ne = fe(/* @__PURE__ */ B().mark(function s(t, e, n, r, i) {
    var a, u, l, f, o, g, h, E, p;
    return B().wrap(function(c) {
      for (; ; )
        switch (c.prev = c.next) {
          case 0:
            return a = R({}, n), delete a.ruleIndex, We.warning = function() {
            }, a.validator && (u = a.validator, a.validator = function() {
              try {
                return u.apply(void 0, arguments);
              } catch (F) {
                return console.error(F), Promise.reject(He);
              }
            }), l = null, a && a.type === "array" && a.defaultField && (l = a.defaultField, delete a.defaultField), f = new We(d({}, t, [a])), o = ie(nr, r.validateMessages), f.messages(o), g = [], c.prev = 10, c.next = 13, Promise.resolve(f.validate(d({}, t, e), R({}, r)));
          case 13:
            c.next = 18;
            break;
          case 15:
            c.prev = 15, c.t0 = c.catch(10), c.t0.errors && (g = c.t0.errors.map(function(F, v) {
              var y = F.message, P = y === He ? o.default : y;
              return /* @__PURE__ */ C.isValidElement(P) ? (
                // Wrap ReactNode with `key`
                /* @__PURE__ */ C.cloneElement(P, {
                  key: "error_".concat(v)
                })
              ) : P;
            }));
          case 18:
            if (!(!g.length && l)) {
              c.next = 23;
              break;
            }
            return c.next = 21, Promise.all(e.map(function(F, v) {
              return Ce("".concat(t, ".").concat(v), F, l, r, i);
            }));
          case 21:
            return h = c.sent, c.abrupt("return", h.reduce(function(F, v) {
              return [].concat(k(F), k(v));
            }, []));
          case 23:
            return E = R(R({}, n), {}, {
              name: t,
              enum: (n.enum || []).join(", ")
            }, i), p = g.map(function(F) {
              return typeof F == "string" ? Gr(F, E) : F;
            }), c.abrupt("return", p);
          case 26:
          case "end":
            return c.stop();
        }
    }, s, null, [[10, 15]]);
  })), Ne.apply(this, arguments);
}
function Jr(s, t, e, n, r, i) {
  var a = s.join("."), u = e.map(function(o, g) {
    var h = o.validator, E = R(R({}, o), {}, {
      ruleIndex: g
    });
    return h && (E.validator = function(p, m, c) {
      var F = !1, v = function() {
        for (var V = arguments.length, $ = new Array(V), N = 0; N < V; N++)
          $[N] = arguments[N];
        Promise.resolve().then(function() {
          D(!F, "Your validator function has already return a promise. `callback` will be ignored."), F || c.apply(void 0, $);
        });
      }, y = h(p, m, v);
      F = y && typeof y.then == "function" && typeof y.catch == "function", D(F, "`callback` is deprecated. Please return a promise instead."), F && y.then(function() {
        c();
      }).catch(function(P) {
        c(P || " ");
      });
    }), E;
  }).sort(function(o, g) {
    var h = o.warningOnly, E = o.ruleIndex, p = g.warningOnly, m = g.ruleIndex;
    return !!h == !!p ? E - m : h ? 1 : -1;
  }), l;
  if (r === !0)
    l = new Promise(/* @__PURE__ */ function() {
      var o = fe(/* @__PURE__ */ B().mark(function g(h, E) {
        var p, m, c;
        return B().wrap(function(v) {
          for (; ; )
            switch (v.prev = v.next) {
              case 0:
                p = 0;
              case 1:
                if (!(p < u.length)) {
                  v.next = 12;
                  break;
                }
                return m = u[p], v.next = 5, Ce(a, t, m, n, i);
              case 5:
                if (c = v.sent, !c.length) {
                  v.next = 9;
                  break;
                }
                return E([{
                  errors: c,
                  rule: m
                }]), v.abrupt("return");
              case 9:
                p += 1, v.next = 1;
                break;
              case 12:
                h([]);
              case 13:
              case "end":
                return v.stop();
            }
        }, g);
      }));
      return function(g, h) {
        return o.apply(this, arguments);
      };
    }());
  else {
    var f = u.map(function(o) {
      return Ce(a, t, o, n, i).then(function(g) {
        return {
          errors: g,
          rule: o
        };
      });
    });
    l = (r ? Yr(f) : Br(f)).then(function(o) {
      return Promise.reject(o);
    });
  }
  return l.catch(function(o) {
    return o;
  }), l;
}
function Br(s) {
  return Re.apply(this, arguments);
}
function Re() {
  return Re = fe(/* @__PURE__ */ B().mark(function s(t) {
    return B().wrap(function(n) {
      for (; ; )
        switch (n.prev = n.next) {
          case 0:
            return n.abrupt("return", Promise.all(t).then(function(r) {
              var i, a = (i = []).concat.apply(i, k(r));
              return a;
            }));
          case 1:
          case "end":
            return n.stop();
        }
    }, s);
  })), Re.apply(this, arguments);
}
function Yr(s) {
  return xe.apply(this, arguments);
}
function xe() {
  return xe = fe(/* @__PURE__ */ B().mark(function s(t) {
    var e;
    return B().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            return e = 0, r.abrupt("return", new Promise(function(i) {
              t.forEach(function(a) {
                a.then(function(u) {
                  u.errors.length && i([u]), e += 1, e === t.length && i([]);
                });
              });
            }));
          case 2:
          case "end":
            return r.stop();
        }
    }, s);
  })), xe.apply(this, arguments);
}
function L(s) {
  return we(s);
}
function ze(s, t) {
  var e = {};
  return t.forEach(function(n) {
    var r = Q(s, n);
    e = Y(e, n, r);
  }), e;
}
function te(s, t) {
  var e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return s && s.some(function(n) {
    return ir(t, n, e);
  });
}
function ir(s, t) {
  var e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  return !s || !t || !e && s.length !== t.length ? !1 : t.every(function(n, r) {
    return s[r] === n;
  });
}
function Zr(s, t) {
  if (s === t)
    return !0;
  if (!s && t || s && !t || !s || !t || U(s) !== "object" || U(t) !== "object")
    return !1;
  var e = Object.keys(s), n = Object.keys(t), r = new Set([].concat(e, n));
  return k(r).every(function(i) {
    var a = s[i], u = t[i];
    return typeof a == "function" && typeof u == "function" ? !0 : a === u;
  });
}
function Qr(s) {
  var t = arguments.length <= 1 ? void 0 : arguments[1];
  return t && t.target && U(t.target) === "object" && s in t.target ? t.target[s] : t;
}
function Ke(s, t, e) {
  var n = s.length;
  if (t < 0 || t >= n || e < 0 || e >= n)
    return s;
  var r = s[t], i = t - e;
  return i > 0 ? [].concat(k(s.slice(0, e)), [r], k(s.slice(e, t)), k(s.slice(t + 1, n))) : i < 0 ? [].concat(k(s.slice(0, t)), k(s.slice(t + 1, e + 1)), [r], k(s.slice(e + 1, n))) : s;
}
var Xr = ["name"], z = [];
function Ge(s, t, e, n, r, i) {
  return typeof s == "function" ? s(t, e, "source" in i ? {
    source: i.source
  } : {}) : n !== r;
}
var $e = /* @__PURE__ */ function(s) {
  Qe(e, s);
  var t = Xe(e);
  function e(n) {
    var r;
    if (oe(this, e), r = t.call(this, n), d(q(r), "state", {
      resetCount: 0
    }), d(q(r), "cancelRegisterFunc", null), d(q(r), "mounted", !1), d(q(r), "touched", !1), d(q(r), "dirty", !1), d(q(r), "validatePromise", void 0), d(q(r), "prevValidating", void 0), d(q(r), "errors", z), d(q(r), "warnings", z), d(q(r), "cancelRegister", function() {
      var l = r.props, f = l.preserve, o = l.isListField, g = l.name;
      r.cancelRegisterFunc && r.cancelRegisterFunc(o, f, L(g)), r.cancelRegisterFunc = null;
    }), d(q(r), "getNamePath", function() {
      var l = r.props, f = l.name, o = l.fieldContext, g = o.prefixName, h = g === void 0 ? [] : g;
      return f !== void 0 ? [].concat(k(h), k(f)) : [];
    }), d(q(r), "getRules", function() {
      var l = r.props, f = l.rules, o = f === void 0 ? [] : f, g = l.fieldContext;
      return o.map(function(h) {
        return typeof h == "function" ? h(g) : h;
      });
    }), d(q(r), "refresh", function() {
      r.mounted && r.setState(function(l) {
        var f = l.resetCount;
        return {
          resetCount: f + 1
        };
      });
    }), d(q(r), "metaCache", null), d(q(r), "triggerMetaEvent", function(l) {
      var f = r.props.onMetaChange;
      if (f) {
        var o = R(R({}, r.getMeta()), {}, {
          destroy: l
        });
        Ie(r.metaCache, o) || f(o), r.metaCache = o;
      } else
        r.metaCache = null;
    }), d(q(r), "onStoreChange", function(l, f, o) {
      var g = r.props, h = g.shouldUpdate, E = g.dependencies, p = E === void 0 ? [] : E, m = g.onReset, c = o.store, F = r.getNamePath(), v = r.getValue(l), y = r.getValue(c), P = f && te(f, F);
      switch (o.type === "valueUpdate" && o.source === "external" && !Ie(v, y) && (r.touched = !0, r.dirty = !0, r.validatePromise = null, r.errors = z, r.warnings = z, r.triggerMetaEvent()), o.type) {
        case "reset":
          if (!f || P) {
            r.touched = !1, r.dirty = !1, r.validatePromise = void 0, r.errors = z, r.warnings = z, r.triggerMetaEvent(), m == null || m(), r.refresh();
            return;
          }
          break;
        case "remove": {
          if (h) {
            r.reRender();
            return;
          }
          break;
        }
        case "setField": {
          var V = o.data;
          if (P) {
            "touched" in V && (r.touched = V.touched), "validating" in V && !("originRCField" in V) && (r.validatePromise = V.validating ? Promise.resolve([]) : null), "errors" in V && (r.errors = V.errors || z), "warnings" in V && (r.warnings = V.warnings || z), r.dirty = !0, r.triggerMetaEvent(), r.reRender();
            return;
          } else if ("value" in V && te(f, F, !0)) {
            r.reRender();
            return;
          }
          if (h && !F.length && Ge(h, l, c, v, y, o)) {
            r.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var $ = p.map(L);
          if ($.some(function(N) {
            return te(o.relatedFields, N);
          })) {
            r.reRender();
            return;
          }
          break;
        }
        default:
          if (P || (!p.length || F.length || h) && Ge(h, l, c, v, y, o)) {
            r.reRender();
            return;
          }
          break;
      }
      h === !0 && r.reRender();
    }), d(q(r), "validateRules", function(l) {
      var f = r.getNamePath(), o = r.getValue(), g = l || {}, h = g.triggerName, E = g.validateOnly, p = E === void 0 ? !1 : E, m = Promise.resolve().then(/* @__PURE__ */ fe(/* @__PURE__ */ B().mark(function c() {
        var F, v, y, P, V, $, N;
        return B().wrap(function(w) {
          for (; ; )
            switch (w.prev = w.next) {
              case 0:
                if (r.mounted) {
                  w.next = 2;
                  break;
                }
                return w.abrupt("return", []);
              case 2:
                if (F = r.props, v = F.validateFirst, y = v === void 0 ? !1 : v, P = F.messageVariables, V = F.validateDebounce, $ = r.getRules(), h && ($ = $.filter(function(b) {
                  return b;
                }).filter(function(b) {
                  var x = b.validateTrigger;
                  if (!x)
                    return !0;
                  var I = we(x);
                  return I.includes(h);
                })), !(V && h)) {
                  w.next = 10;
                  break;
                }
                return w.next = 8, new Promise(function(b) {
                  setTimeout(b, V);
                });
              case 8:
                if (r.validatePromise === m) {
                  w.next = 10;
                  break;
                }
                return w.abrupt("return", []);
              case 10:
                return N = Jr(f, o, $, l, y, P), N.catch(function(b) {
                  return b;
                }).then(function() {
                  var b = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : z;
                  if (r.validatePromise === m) {
                    var x;
                    r.validatePromise = null;
                    var I = [], T = [];
                    (x = b.forEach) === null || x === void 0 || x.call(b, function(M) {
                      var K = M.rule.warningOnly, _ = M.errors, G = _ === void 0 ? z : _;
                      K ? T.push.apply(T, k(G)) : I.push.apply(I, k(G));
                    }), r.errors = I, r.warnings = T, r.triggerMetaEvent(), r.reRender();
                  }
                }), w.abrupt("return", N);
              case 13:
              case "end":
                return w.stop();
            }
        }, c);
      })));
      return p || (r.validatePromise = m, r.dirty = !0, r.errors = z, r.warnings = z, r.triggerMetaEvent(), r.reRender()), m;
    }), d(q(r), "isFieldValidating", function() {
      return !!r.validatePromise;
    }), d(q(r), "isFieldTouched", function() {
      return r.touched;
    }), d(q(r), "isFieldDirty", function() {
      if (r.dirty || r.props.initialValue !== void 0)
        return !0;
      var l = r.props.fieldContext, f = l.getInternalHooks(X), o = f.getInitialValue;
      return o(r.getNamePath()) !== void 0;
    }), d(q(r), "getErrors", function() {
      return r.errors;
    }), d(q(r), "getWarnings", function() {
      return r.warnings;
    }), d(q(r), "isListField", function() {
      return r.props.isListField;
    }), d(q(r), "isList", function() {
      return r.props.isList;
    }), d(q(r), "isPreserve", function() {
      return r.props.preserve;
    }), d(q(r), "getMeta", function() {
      r.prevValidating = r.isFieldValidating();
      var l = {
        touched: r.isFieldTouched(),
        validating: r.prevValidating,
        errors: r.errors,
        warnings: r.warnings,
        name: r.getNamePath(),
        validated: r.validatePromise === null
      };
      return l;
    }), d(q(r), "getOnlyChild", function(l) {
      if (typeof l == "function") {
        var f = r.getMeta();
        return R(R({}, r.getOnlyChild(l(r.getControlled(), f, r.props.fieldContext))), {}, {
          isFunction: !0
        });
      }
      var o = hr(l);
      return o.length !== 1 || !/* @__PURE__ */ C.isValidElement(o[0]) ? {
        child: o,
        isFunction: !1
      } : {
        child: o[0],
        isFunction: !1
      };
    }), d(q(r), "getValue", function(l) {
      var f = r.props.fieldContext.getFieldsValue, o = r.getNamePath();
      return Q(l || f(!0), o);
    }), d(q(r), "getControlled", function() {
      var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, f = r.props, o = f.name, g = f.trigger, h = f.validateTrigger, E = f.getValueFromEvent, p = f.normalize, m = f.valuePropName, c = f.getValueProps, F = f.fieldContext, v = h !== void 0 ? h : F.validateTrigger, y = r.getNamePath(), P = F.getInternalHooks, V = F.getFieldsValue, $ = P(X), N = $.dispatch, O = r.getValue(), w = c || function(M) {
        return d({}, m, M);
      }, b = l[g], x = o !== void 0 ? w(O) : {};
      process.env.NODE_ENV !== "production" && x && Object.keys(x).forEach(function(M) {
        D(typeof x[M] != "function", "It's not recommended to generate dynamic function prop by `getValueProps`. Please pass it to child component directly (prop: ".concat(M, ")"));
      });
      var I = R(R({}, l), x);
      I[g] = function() {
        r.touched = !0, r.dirty = !0, r.triggerMetaEvent();
        for (var M, K = arguments.length, _ = new Array(K), G = 0; G < K; G++)
          _[G] = arguments[G];
        E ? M = E.apply(void 0, _) : M = Qr.apply(void 0, [m].concat(_)), p && (M = p(M, O, V(!0))), N({
          type: "updateValue",
          namePath: y,
          value: M
        }), b && b.apply(void 0, _);
      };
      var T = we(v || []);
      return T.forEach(function(M) {
        var K = I[M];
        I[M] = function() {
          K && K.apply(void 0, arguments);
          var _ = r.props.rules;
          _ && _.length && N({
            type: "validateField",
            namePath: y,
            triggerName: M
          });
        };
      }), I;
    }), n.fieldContext) {
      var i = n.fieldContext.getInternalHooks, a = i(X), u = a.initEntityValue;
      u(q(r));
    }
    return r;
  }
  return le(e, [{
    key: "componentDidMount",
    value: function() {
      var r = this.props, i = r.shouldUpdate, a = r.fieldContext;
      if (this.mounted = !0, a) {
        var u = a.getInternalHooks, l = u(X), f = l.registerField;
        this.cancelRegisterFunc = f(this);
      }
      i === !0 && this.reRender();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.cancelRegister(), this.triggerMetaEvent(!0), this.mounted = !1;
    }
  }, {
    key: "reRender",
    value: function() {
      this.mounted && this.forceUpdate();
    }
  }, {
    key: "render",
    value: function() {
      var r = this.state.resetCount, i = this.props.children, a = this.getOnlyChild(i), u = a.child, l = a.isFunction, f;
      return l ? f = u : /* @__PURE__ */ C.isValidElement(u) ? f = /* @__PURE__ */ C.cloneElement(u, this.getControlled(u.props)) : (D(!u, "`children` of Field is not validate ReactElement."), f = u), /* @__PURE__ */ C.createElement(C.Fragment, {
        key: r
      }, f);
    }
  }]), e;
}(C.Component);
d($e, "contextType", ne);
d($e, "defaultProps", {
  trigger: "onChange",
  valuePropName: "value"
});
function ar(s) {
  var t = s.name, e = Ae(s, Xr), n = C.useContext(ne), r = C.useContext(he), i = t !== void 0 ? L(t) : void 0, a = "keep";
  return e.isListField || (a = "_".concat((i || []).join("_"))), process.env.NODE_ENV !== "production" && e.preserve === !1 && e.isListField && i.length <= 1 && D(!1, "`preserve` should not apply on Form.List fields."), /* @__PURE__ */ C.createElement($e, er({
    key: a,
    name: i,
    isListField: !!r
  }, e, {
    fieldContext: n
  }));
}
function et(s) {
  var t = s.name, e = s.initialValue, n = s.children, r = s.rules, i = s.validateTrigger, a = s.isListField, u = C.useContext(ne), l = C.useContext(he), f = C.useRef({
    keys: [],
    id: 0
  }), o = f.current, g = C.useMemo(function() {
    var m = L(u.prefixName) || [];
    return [].concat(k(m), k(L(t)));
  }, [u.prefixName, t]), h = C.useMemo(function() {
    return R(R({}, u), {}, {
      prefixName: g
    });
  }, [u, g]), E = C.useMemo(function() {
    return {
      getKey: function(c) {
        var F = g.length, v = c[F];
        return [o.keys[v], c.slice(F + 1)];
      }
    };
  }, [g]);
  if (typeof n != "function")
    return D(!1, "Form.List only accepts function as children."), null;
  var p = function(c, F, v) {
    var y = v.source;
    return y === "internal" ? !1 : c !== F;
  };
  return /* @__PURE__ */ C.createElement(he.Provider, {
    value: E
  }, /* @__PURE__ */ C.createElement(ne.Provider, {
    value: h
  }, /* @__PURE__ */ C.createElement(ar, {
    name: [],
    shouldUpdate: p,
    rules: r,
    validateTrigger: i,
    initialValue: e,
    isList: !0,
    isListField: a ?? !!l
  }, function(m, c) {
    var F = m.value, v = F === void 0 ? [] : F, y = m.onChange, P = u.getFieldValue, V = function() {
      var w = P(g || []);
      return w || [];
    }, $ = {
      add: function(w, b) {
        var x = V();
        b >= 0 && b <= x.length ? (o.keys = [].concat(k(o.keys.slice(0, b)), [o.id], k(o.keys.slice(b))), y([].concat(k(x.slice(0, b)), [w], k(x.slice(b))))) : (process.env.NODE_ENV !== "production" && (b < 0 || b > x.length) && D(!1, "The second parameter of the add function should be a valid positive number."), o.keys = [].concat(k(o.keys), [o.id]), y([].concat(k(x), [w]))), o.id += 1;
      },
      remove: function(w) {
        var b = V(), x = new Set(Array.isArray(w) ? w : [w]);
        x.size <= 0 || (o.keys = o.keys.filter(function(I, T) {
          return !x.has(T);
        }), y(b.filter(function(I, T) {
          return !x.has(T);
        })));
      },
      move: function(w, b) {
        if (w !== b) {
          var x = V();
          w < 0 || w >= x.length || b < 0 || b >= x.length || (o.keys = Ke(o.keys, w, b), y(Ke(x, w, b)));
        }
      }
    }, N = v || [];
    return Array.isArray(N) || (N = [], process.env.NODE_ENV !== "production" && D(!1, "Current value of '".concat(g.join(" > "), "' is not an array type."))), n(N.map(function(O, w) {
      var b = o.keys[w];
      return b === void 0 && (o.keys[w] = o.id, b = o.keys[w], o.id += 1), {
        name: w,
        key: b,
        isListField: !0
      };
    }), $, c);
  })));
}
function rt(s) {
  var t = !1, e = s.length, n = [];
  return s.length ? new Promise(function(r, i) {
    s.forEach(function(a, u) {
      a.catch(function(l) {
        return t = !0, l;
      }).then(function(l) {
        e -= 1, n[u] = l, !(e > 0) && (t && i(n), r(n));
      });
    });
  }) : Promise.resolve([]);
}
var sr = "__@field_split__";
function Fe(s) {
  return s.map(function(t) {
    return "".concat(U(t), ":").concat(t);
  }).join(sr);
}
var re = /* @__PURE__ */ function() {
  function s() {
    oe(this, s), d(this, "kvs", /* @__PURE__ */ new Map());
  }
  return le(s, [{
    key: "set",
    value: function(e, n) {
      this.kvs.set(Fe(e), n);
    }
  }, {
    key: "get",
    value: function(e) {
      return this.kvs.get(Fe(e));
    }
  }, {
    key: "update",
    value: function(e, n) {
      var r = this.get(e), i = n(r);
      i ? this.set(e, i) : this.delete(e);
    }
  }, {
    key: "delete",
    value: function(e) {
      this.kvs.delete(Fe(e));
    }
    // Since we only use this in test, let simply realize this
  }, {
    key: "map",
    value: function(e) {
      return k(this.kvs.entries()).map(function(n) {
        var r = ue(n, 2), i = r[0], a = r[1], u = i.split(sr);
        return e({
          key: u.map(function(l) {
            var f = l.match(/^([^:]*):(.*)$/), o = ue(f, 3), g = o[1], h = o[2];
            return g === "number" ? Number(h) : h;
          }),
          value: a
        });
      });
    }
  }, {
    key: "toJSON",
    value: function() {
      var e = {};
      return this.map(function(n) {
        var r = n.key, i = n.value;
        return e[r.join(".")] = i, null;
      }), e;
    }
  }]), s;
}(), tt = ["name"], nt = /* @__PURE__ */ le(function s(t) {
  var e = this;
  oe(this, s), d(this, "formHooked", !1), d(this, "forceRootUpdate", void 0), d(this, "subscribable", !0), d(this, "store", {}), d(this, "fieldEntities", []), d(this, "initialValues", {}), d(this, "callbacks", {}), d(this, "validateMessages", null), d(this, "preserve", null), d(this, "lastValidatePromise", null), d(this, "getForm", function() {
    return {
      getFieldValue: e.getFieldValue,
      getFieldsValue: e.getFieldsValue,
      getFieldError: e.getFieldError,
      getFieldWarning: e.getFieldWarning,
      getFieldsError: e.getFieldsError,
      isFieldsTouched: e.isFieldsTouched,
      isFieldTouched: e.isFieldTouched,
      isFieldValidating: e.isFieldValidating,
      isFieldsValidating: e.isFieldsValidating,
      resetFields: e.resetFields,
      setFields: e.setFields,
      setFieldValue: e.setFieldValue,
      setFieldsValue: e.setFieldsValue,
      validateFields: e.validateFields,
      submit: e.submit,
      _init: !0,
      getInternalHooks: e.getInternalHooks
    };
  }), d(this, "getInternalHooks", function(n) {
    return n === X ? (e.formHooked = !0, {
      dispatch: e.dispatch,
      initEntityValue: e.initEntityValue,
      registerField: e.registerField,
      useSubscribe: e.useSubscribe,
      setInitialValues: e.setInitialValues,
      destroyForm: e.destroyForm,
      setCallbacks: e.setCallbacks,
      setValidateMessages: e.setValidateMessages,
      getFields: e.getFields,
      setPreserve: e.setPreserve,
      getInitialValue: e.getInitialValue,
      registerWatch: e.registerWatch
    }) : (D(!1, "`getInternalHooks` is internal usage. Should not call directly."), null);
  }), d(this, "useSubscribe", function(n) {
    e.subscribable = n;
  }), d(this, "prevWithoutPreserves", null), d(this, "setInitialValues", function(n, r) {
    if (e.initialValues = n || {}, r) {
      var i, a = ie(n, e.store);
      (i = e.prevWithoutPreserves) === null || i === void 0 || i.map(function(u) {
        var l = u.key;
        a = Y(a, l, Q(n, l));
      }), e.prevWithoutPreserves = null, e.updateStore(a);
    }
  }), d(this, "destroyForm", function(n) {
    if (n)
      e.updateStore({});
    else {
      var r = new re();
      e.getFieldEntities(!0).forEach(function(i) {
        e.isMergedPreserve(i.isPreserve()) || r.set(i.getNamePath(), !0);
      }), e.prevWithoutPreserves = r;
    }
  }), d(this, "getInitialValue", function(n) {
    var r = Q(e.initialValues, n);
    return n.length ? ie(r) : r;
  }), d(this, "setCallbacks", function(n) {
    e.callbacks = n;
  }), d(this, "setValidateMessages", function(n) {
    e.validateMessages = n;
  }), d(this, "setPreserve", function(n) {
    e.preserve = n;
  }), d(this, "watchList", []), d(this, "registerWatch", function(n) {
    return e.watchList.push(n), function() {
      e.watchList = e.watchList.filter(function(r) {
        return r !== n;
      });
    };
  }), d(this, "notifyWatch", function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (e.watchList.length) {
      var r = e.getFieldsValue(), i = e.getFieldsValue(!0);
      e.watchList.forEach(function(a) {
        a(r, i, n);
      });
    }
  }), d(this, "timeoutId", null), d(this, "warningUnhooked", function() {
    process.env.NODE_ENV !== "production" && !e.timeoutId && typeof window < "u" && (e.timeoutId = setTimeout(function() {
      e.timeoutId = null, e.formHooked || D(!1, "Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?");
    }));
  }), d(this, "updateStore", function(n) {
    e.store = n;
  }), d(this, "getFieldEntities", function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
    return n ? e.fieldEntities.filter(function(r) {
      return r.getNamePath().length;
    }) : e.fieldEntities;
  }), d(this, "getFieldsMap", function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, r = new re();
    return e.getFieldEntities(n).forEach(function(i) {
      var a = i.getNamePath();
      r.set(a, i);
    }), r;
  }), d(this, "getFieldEntitiesForNamePathList", function(n) {
    if (!n)
      return e.getFieldEntities(!0);
    var r = e.getFieldsMap(!0);
    return n.map(function(i) {
      var a = L(i);
      return r.get(a) || {
        INVALIDATE_NAME_PATH: L(i)
      };
    });
  }), d(this, "getFieldsValue", function(n, r) {
    e.warningUnhooked();
    var i, a, u;
    if (n === !0 || Array.isArray(n) ? (i = n, a = r) : n && U(n) === "object" && (u = n.strict, a = n.filter), i === !0 && !a)
      return e.store;
    var l = e.getFieldEntitiesForNamePathList(Array.isArray(i) ? i : null), f = [];
    return l.forEach(function(o) {
      var g, h, E = "INVALIDATE_NAME_PATH" in o ? o.INVALIDATE_NAME_PATH : o.getNamePath();
      if (u) {
        var p, m;
        if ((p = (m = o).isList) !== null && p !== void 0 && p.call(m))
          return;
      } else if (!i && (g = (h = o).isListField) !== null && g !== void 0 && g.call(h))
        return;
      if (!a)
        f.push(E);
      else {
        var c = "getMeta" in o ? o.getMeta() : null;
        a(c) && f.push(E);
      }
    }), ze(e.store, f.map(L));
  }), d(this, "getFieldValue", function(n) {
    e.warningUnhooked();
    var r = L(n);
    return Q(e.store, r);
  }), d(this, "getFieldsError", function(n) {
    e.warningUnhooked();
    var r = e.getFieldEntitiesForNamePathList(n);
    return r.map(function(i, a) {
      return i && !("INVALIDATE_NAME_PATH" in i) ? {
        name: i.getNamePath(),
        errors: i.getErrors(),
        warnings: i.getWarnings()
      } : {
        name: L(n[a]),
        errors: [],
        warnings: []
      };
    });
  }), d(this, "getFieldError", function(n) {
    e.warningUnhooked();
    var r = L(n), i = e.getFieldsError([r])[0];
    return i.errors;
  }), d(this, "getFieldWarning", function(n) {
    e.warningUnhooked();
    var r = L(n), i = e.getFieldsError([r])[0];
    return i.warnings;
  }), d(this, "isFieldsTouched", function() {
    e.warningUnhooked();
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    var a = r[0], u = r[1], l, f = !1;
    r.length === 0 ? l = null : r.length === 1 ? Array.isArray(a) ? (l = a.map(L), f = !1) : (l = null, f = a) : (l = a.map(L), f = u);
    var o = e.getFieldEntities(!0), g = function(c) {
      return c.isFieldTouched();
    };
    if (!l)
      return f ? o.every(function(m) {
        return g(m) || m.isList();
      }) : o.some(g);
    var h = new re();
    l.forEach(function(m) {
      h.set(m, []);
    }), o.forEach(function(m) {
      var c = m.getNamePath();
      l.forEach(function(F) {
        F.every(function(v, y) {
          return c[y] === v;
        }) && h.update(F, function(v) {
          return [].concat(k(v), [m]);
        });
      });
    });
    var E = function(c) {
      return c.some(g);
    }, p = h.map(function(m) {
      var c = m.value;
      return c;
    });
    return f ? p.every(E) : p.some(E);
  }), d(this, "isFieldTouched", function(n) {
    return e.warningUnhooked(), e.isFieldsTouched([n]);
  }), d(this, "isFieldsValidating", function(n) {
    e.warningUnhooked();
    var r = e.getFieldEntities();
    if (!n)
      return r.some(function(a) {
        return a.isFieldValidating();
      });
    var i = n.map(L);
    return r.some(function(a) {
      var u = a.getNamePath();
      return te(i, u) && a.isFieldValidating();
    });
  }), d(this, "isFieldValidating", function(n) {
    return e.warningUnhooked(), e.isFieldsValidating([n]);
  }), d(this, "resetWithFieldInitialValue", function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = new re(), i = e.getFieldEntities(!0);
    i.forEach(function(l) {
      var f = l.props.initialValue, o = l.getNamePath();
      if (f !== void 0) {
        var g = r.get(o) || /* @__PURE__ */ new Set();
        g.add({
          entity: l,
          value: f
        }), r.set(o, g);
      }
    });
    var a = function(f) {
      f.forEach(function(o) {
        var g = o.props.initialValue;
        if (g !== void 0) {
          var h = o.getNamePath(), E = e.getInitialValue(h);
          if (E !== void 0)
            D(!1, "Form already set 'initialValues' with path '".concat(h.join("."), "'. Field can not overwrite it."));
          else {
            var p = r.get(h);
            if (p && p.size > 1)
              D(!1, "Multiple Field with path '".concat(h.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            else if (p) {
              var m = e.getFieldValue(h), c = o.isListField();
              !c && (!n.skipExist || m === void 0) && e.updateStore(Y(e.store, h, k(p)[0].value));
            }
          }
        }
      });
    }, u;
    n.entities ? u = n.entities : n.namePathList ? (u = [], n.namePathList.forEach(function(l) {
      var f = r.get(l);
      if (f) {
        var o;
        (o = u).push.apply(o, k(k(f).map(function(g) {
          return g.entity;
        })));
      }
    })) : u = i, a(u);
  }), d(this, "resetFields", function(n) {
    e.warningUnhooked();
    var r = e.store;
    if (!n) {
      e.updateStore(ie(e.initialValues)), e.resetWithFieldInitialValue(), e.notifyObservers(r, null, {
        type: "reset"
      }), e.notifyWatch();
      return;
    }
    var i = n.map(L);
    i.forEach(function(a) {
      var u = e.getInitialValue(a);
      e.updateStore(Y(e.store, a, u));
    }), e.resetWithFieldInitialValue({
      namePathList: i
    }), e.notifyObservers(r, i, {
      type: "reset"
    }), e.notifyWatch(i);
  }), d(this, "setFields", function(n) {
    e.warningUnhooked();
    var r = e.store, i = [];
    n.forEach(function(a) {
      var u = a.name, l = Ae(a, tt), f = L(u);
      i.push(f), "value" in l && e.updateStore(Y(e.store, f, l.value)), e.notifyObservers(r, [f], {
        type: "setField",
        data: a
      });
    }), e.notifyWatch(i);
  }), d(this, "getFields", function() {
    var n = e.getFieldEntities(!0), r = n.map(function(i) {
      var a = i.getNamePath(), u = i.getMeta(), l = R(R({}, u), {}, {
        name: a,
        value: e.getFieldValue(a)
      });
      return Object.defineProperty(l, "originRCField", {
        value: !0
      }), l;
    });
    return r;
  }), d(this, "initEntityValue", function(n) {
    var r = n.props.initialValue;
    if (r !== void 0) {
      var i = n.getNamePath(), a = Q(e.store, i);
      a === void 0 && e.updateStore(Y(e.store, i, r));
    }
  }), d(this, "isMergedPreserve", function(n) {
    var r = n !== void 0 ? n : e.preserve;
    return r ?? !0;
  }), d(this, "registerField", function(n) {
    e.fieldEntities.push(n);
    var r = n.getNamePath();
    if (e.notifyWatch([r]), n.props.initialValue !== void 0) {
      var i = e.store;
      e.resetWithFieldInitialValue({
        entities: [n],
        skipExist: !0
      }), e.notifyObservers(i, [n.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(a, u) {
      var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      if (e.fieldEntities = e.fieldEntities.filter(function(g) {
        return g !== n;
      }), !e.isMergedPreserve(u) && (!a || l.length > 1)) {
        var f = a ? void 0 : e.getInitialValue(r);
        if (r.length && e.getFieldValue(r) !== f && e.fieldEntities.every(function(g) {
          return (
            // Only reset when no namePath exist
            !ir(g.getNamePath(), r)
          );
        })) {
          var o = e.store;
          e.updateStore(Y(o, r, f, !0)), e.notifyObservers(o, [r], {
            type: "remove"
          }), e.triggerDependenciesUpdate(o, r);
        }
      }
      e.notifyWatch([r]);
    };
  }), d(this, "dispatch", function(n) {
    switch (n.type) {
      case "updateValue": {
        var r = n.namePath, i = n.value;
        e.updateValue(r, i);
        break;
      }
      case "validateField": {
        var a = n.namePath, u = n.triggerName;
        e.validateFields([a], {
          triggerName: u
        });
        break;
      }
    }
  }), d(this, "notifyObservers", function(n, r, i) {
    if (e.subscribable) {
      var a = R(R({}, i), {}, {
        store: e.getFieldsValue(!0)
      });
      e.getFieldEntities().forEach(function(u) {
        var l = u.onStoreChange;
        l(n, r, a);
      });
    } else
      e.forceRootUpdate();
  }), d(this, "triggerDependenciesUpdate", function(n, r) {
    var i = e.getDependencyChildrenFields(r);
    return i.length && e.validateFields(i), e.notifyObservers(n, i, {
      type: "dependenciesUpdate",
      relatedFields: [r].concat(k(i))
    }), i;
  }), d(this, "updateValue", function(n, r) {
    var i = L(n), a = e.store;
    e.updateStore(Y(e.store, i, r)), e.notifyObservers(a, [i], {
      type: "valueUpdate",
      source: "internal"
    }), e.notifyWatch([i]);
    var u = e.triggerDependenciesUpdate(a, i), l = e.callbacks.onValuesChange;
    if (l) {
      var f = ze(e.store, [i]);
      l(f, e.getFieldsValue());
    }
    e.triggerOnFieldsChange([i].concat(k(u)));
  }), d(this, "setFieldsValue", function(n) {
    e.warningUnhooked();
    var r = e.store;
    if (n) {
      var i = ie(e.store, n);
      e.updateStore(i);
    }
    e.notifyObservers(r, null, {
      type: "valueUpdate",
      source: "external"
    }), e.notifyWatch();
  }), d(this, "setFieldValue", function(n, r) {
    e.setFields([{
      name: n,
      value: r
    }]);
  }), d(this, "getDependencyChildrenFields", function(n) {
    var r = /* @__PURE__ */ new Set(), i = [], a = new re();
    e.getFieldEntities().forEach(function(l) {
      var f = l.props.dependencies;
      (f || []).forEach(function(o) {
        var g = L(o);
        a.update(g, function() {
          var h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          return h.add(l), h;
        });
      });
    });
    var u = function l(f) {
      var o = a.get(f) || /* @__PURE__ */ new Set();
      o.forEach(function(g) {
        if (!r.has(g)) {
          r.add(g);
          var h = g.getNamePath();
          g.isFieldDirty() && h.length && (i.push(h), l(h));
        }
      });
    };
    return u(n), i;
  }), d(this, "triggerOnFieldsChange", function(n, r) {
    var i = e.callbacks.onFieldsChange;
    if (i) {
      var a = e.getFields();
      if (r) {
        var u = new re();
        r.forEach(function(f) {
          var o = f.name, g = f.errors;
          u.set(o, g);
        }), a.forEach(function(f) {
          f.errors = u.get(f.name) || f.errors;
        });
      }
      var l = a.filter(function(f) {
        var o = f.name;
        return te(n, o);
      });
      l.length && i(l, a);
    }
  }), d(this, "validateFields", function(n, r) {
    e.warningUnhooked();
    var i, a;
    Array.isArray(n) || typeof n == "string" || typeof r == "string" ? (i = n, a = r) : a = n;
    var u = !!i, l = u ? i.map(L) : [], f = [], o = String(Date.now()), g = /* @__PURE__ */ new Set(), h = a || {}, E = h.recursive, p = h.dirty;
    e.getFieldEntities(!0).forEach(function(v) {
      if (u || l.push(v.getNamePath()), !(!v.props.rules || !v.props.rules.length) && !(p && !v.isFieldDirty())) {
        var y = v.getNamePath();
        if (g.add(y.join(o)), !u || te(l, y, E)) {
          var P = v.validateRules(R({
            validateMessages: R(R({}, nr), e.validateMessages)
          }, a));
          f.push(P.then(function() {
            return {
              name: y,
              errors: [],
              warnings: []
            };
          }).catch(function(V) {
            var $, N = [], O = [];
            return ($ = V.forEach) === null || $ === void 0 || $.call(V, function(w) {
              var b = w.rule.warningOnly, x = w.errors;
              b ? O.push.apply(O, k(x)) : N.push.apply(N, k(x));
            }), N.length ? Promise.reject({
              name: y,
              errors: N,
              warnings: O
            }) : {
              name: y,
              errors: N,
              warnings: O
            };
          }));
        }
      }
    });
    var m = rt(f);
    e.lastValidatePromise = m, m.catch(function(v) {
      return v;
    }).then(function(v) {
      var y = v.map(function(P) {
        var V = P.name;
        return V;
      });
      e.notifyObservers(e.store, y, {
        type: "validateFinish"
      }), e.triggerOnFieldsChange(y, v);
    });
    var c = m.then(function() {
      return e.lastValidatePromise === m ? Promise.resolve(e.getFieldsValue(l)) : Promise.reject([]);
    }).catch(function(v) {
      var y = v.filter(function(P) {
        return P && P.errors.length;
      });
      return Promise.reject({
        values: e.getFieldsValue(l),
        errorFields: y,
        outOfDate: e.lastValidatePromise !== m
      });
    });
    c.catch(function(v) {
      return v;
    });
    var F = l.filter(function(v) {
      return g.has(v.join(o));
    });
    return e.triggerOnFieldsChange(F), c;
  }), d(this, "submit", function() {
    e.warningUnhooked(), e.validateFields().then(function(n) {
      var r = e.callbacks.onFinish;
      if (r)
        try {
          r(n);
        } catch (i) {
          console.error(i);
        }
    }).catch(function(n) {
      var r = e.callbacks.onFinishFailed;
      r && r(n);
    });
  }), this.forceRootUpdate = t;
});
function ur(s) {
  var t = C.useRef(), e = C.useState({}), n = ue(e, 2), r = n[1];
  if (!t.current)
    if (s)
      t.current = s;
    else {
      var i = function() {
        r({});
      }, a = new nt(i);
      t.current = a.getForm();
    }
  return [t.current];
}
var ke = /* @__PURE__ */ C.createContext({
  triggerFormChange: function() {
  },
  triggerFormFinish: function() {
  },
  registerForm: function() {
  },
  unregisterForm: function() {
  }
}), it = function(t) {
  var e = t.validateMessages, n = t.onFormChange, r = t.onFormFinish, i = t.children, a = C.useContext(ke), u = C.useRef({});
  return /* @__PURE__ */ C.createElement(ke.Provider, {
    value: R(R({}, a), {}, {
      validateMessages: R(R({}, a.validateMessages), e),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function(f, o) {
        n && n(f, {
          changedFields: o,
          forms: u.current
        }), a.triggerFormChange(f, o);
      },
      triggerFormFinish: function(f, o) {
        r && r(f, {
          values: o,
          forms: u.current
        }), a.triggerFormFinish(f, o);
      },
      registerForm: function(f, o) {
        f && (u.current = R(R({}, u.current), {}, d({}, f, o))), a.registerForm(f, o);
      },
      unregisterForm: function(f) {
        var o = R({}, u.current);
        delete o[f], u.current = o, a.unregisterForm(f);
      }
    })
  }, i);
}, at = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed", "clearOnDestroy"], st = function(t, e) {
  var n = t.name, r = t.initialValues, i = t.fields, a = t.form, u = t.preserve, l = t.children, f = t.component, o = f === void 0 ? "form" : f, g = t.validateMessages, h = t.validateTrigger, E = h === void 0 ? "onChange" : h, p = t.onValuesChange, m = t.onFieldsChange, c = t.onFinish, F = t.onFinishFailed, v = t.clearOnDestroy, y = Ae(t, at), P = C.useRef(null), V = C.useContext(ke), $ = ur(a), N = ue($, 1), O = N[0], w = O.getInternalHooks(X), b = w.useSubscribe, x = w.setInitialValues, I = w.setCallbacks, T = w.setValidateMessages, M = w.setPreserve, K = w.destroyForm;
  C.useImperativeHandle(e, function() {
    return R(R({}, O), {}, {
      nativeElement: P.current
    });
  }), C.useEffect(function() {
    return V.registerForm(n, O), function() {
      V.unregisterForm(n);
    };
  }, [V, O, n]), T(R(R({}, V.validateMessages), g)), I({
    onValuesChange: p,
    onFieldsChange: function(J) {
      if (V.triggerFormChange(n, J), m) {
        for (var Z = arguments.length, Te = new Array(Z > 1 ? Z - 1 : 0), ge = 1; ge < Z; ge++)
          Te[ge - 1] = arguments[ge];
        m.apply(void 0, [J].concat(Te));
      }
    },
    onFinish: function(J) {
      V.triggerFormFinish(n, J), c && c(J);
    },
    onFinishFailed: F
  }), M(u);
  var _ = C.useRef(null);
  x(r, !_.current), _.current || (_.current = !0), C.useEffect(
    function() {
      return function() {
        return K(v);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  var G, qe = typeof l == "function";
  if (qe) {
    var or = O.getFieldsValue(!0);
    G = l(or, O);
  } else
    G = l;
  b(!qe);
  var Me = C.useRef();
  C.useEffect(function() {
    Zr(Me.current || [], i || []) || O.setFields(i || []), Me.current = i;
  }, [i, O]);
  var lr = C.useMemo(function() {
    return R(R({}, O), {}, {
      validateTrigger: E
    });
  }, [O, E]), Se = /* @__PURE__ */ C.createElement(he.Provider, {
    value: null
  }, /* @__PURE__ */ C.createElement(ne.Provider, {
    value: lr
  }, G));
  return o === !1 ? Se : /* @__PURE__ */ C.createElement(o, er({}, y, {
    ref: P,
    onSubmit: function(J) {
      J.preventDefault(), J.stopPropagation(), O.submit();
    },
    onReset: function(J) {
      var Z;
      J.preventDefault(), O.resetFields(), (Z = y.onReset) === null || Z === void 0 || Z.call(y, J);
    }
  }), Se);
};
function Je(s) {
  try {
    return JSON.stringify(s);
  } catch {
    return Math.random();
  }
}
var ut = process.env.NODE_ENV !== "production" ? function(s) {
  var t = s.join("__RC_FIELD_FORM_SPLIT__"), e = ye(t);
  D(e.current === t, "`useWatch` is not support dynamic `namePath`. Please provide static instead.");
} : function() {
};
function ot() {
  for (var s = arguments.length, t = new Array(s), e = 0; e < s; e++)
    t[e] = arguments[e];
  var n = t[0], r = t[1], i = r === void 0 ? {} : r, a = mr(i) ? {
    form: i
  } : i, u = a.form, l = fr(), f = ue(l, 2), o = f[0], g = f[1], h = Be(function() {
    return Je(o);
  }, [o]), E = ye(h);
  E.current = h;
  var p = Ye(ne), m = u || p, c = m && m._init;
  process.env.NODE_ENV !== "production" && D(t.length === 2 ? u ? c : !0 : c, "useWatch requires a form instance since it can not auto detect from context.");
  var F = L(n), v = ye(F);
  return v.current = F, ut(F), cr(
    function() {
      if (c) {
        var y = m.getFieldsValue, P = m.getInternalHooks, V = P(X), $ = V.registerWatch, N = function(x, I) {
          var T = a.preserve ? I : x;
          return typeof n == "function" ? n(T) : Q(T, v.current);
        }, O = $(function(b, x) {
          var I = N(b, x), T = Je(I);
          E.current !== T && (E.current = T, g(I));
        }), w = N(y(), y(!0));
        return o !== w && g(w), O;
      }
    },
    // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [c]
  ), o;
}
var lt = /* @__PURE__ */ C.forwardRef(st), de = lt;
de.FormProvider = it;
de.Field = ar;
de.List = et;
de.useForm = ur;
de.useWatch = ot;
const Oe = /* @__PURE__ */ C.createContext({});
process.env.NODE_ENV !== "production" && (Oe.displayName = "FormItemInputContext");
const vt = (s) => {
  let {
    children: t,
    status: e,
    override: n
  } = s;
  const r = Ye(Oe), i = Be(() => {
    const a = Object.assign({}, r);
    return n && delete a.isFormItemInput, e && (delete a.status, delete a.hasFeedback, delete a.feedbackIcon), a;
  }, [e, n, r]);
  return /* @__PURE__ */ C.createElement(Oe.Provider, {
    value: i
  }, t);
}, ht = /* @__PURE__ */ dr(void 0);
export {
  Oe as F,
  vt as N,
  ht as V
};
//# sourceMappingURL=context-CqAjIyj3.mjs.map
